import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Select from 'react-select';
import Modal from '../../components/Modal';
import StoresHelper from '../../components/storesHelper';
import { header } from '../../components/header.encry';
import { toast } from 'react-toastify';

function SlidesShowForm({ currentSlideShow, onClose, onSave }) {
    const defaultForm = {
        stores: [],
        description: '',
        url: '',
        preview: null, // for previewing newly chosen image
        imageFile: null,
    };
    const [formData, setFormData] = useState(defaultForm);
    const [storeOptions, setStoreOptions] = useState([]);

    const getStores = async () => {
        const stores = await StoresHelper();
        // ✅ Standardize to { value, label }
        const options = stores.map(store => ({
            value: store.id, // assuming `store.id` exists
            label: store.label,
        }));
        setStoreOptions(options);
    };
    useEffect(() => {
        getStores();
        if (currentSlideShow) {
            setFormData({
                description: currentSlideShow.description || '',
                url: currentSlideShow.url || '',
                imageFile: null,
                preview: null, // for previewing newly chosen image
                stores: currentSlideShow.stores?.map(store => ({
                    storeid: typeof store.storeid === 'object' ? store.storeid._id : store.storeid,
                    position: store.position || 0,
                    activated: store.activated ?? true,
                })) || [],
            });
        } else {
            setFormData(defaultForm);
        }
    }, [currentSlideShow]);



    const handleStoreChange = (selectedOptions) => {
        const updatedStores = selectedOptions.map(option => ({
            storeid: option.value, // ✅ use `value` instead of `id`
            position: 0,
            activated: true,
        }));
        setFormData(prev => ({ ...prev, stores: updatedStores }));
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        toast.info("Slide en cours de création");
        try {
            const finalFormData = {
                ...formData,
                stores: formData.stores.map(store => ({
                    storeid: store.storeid,
                    position: store.position,
                    activated: store.activated,
                })),
            };

            // Si une image a été sélectionnée, on l’upload et on récupère l’URL
            if (formData.imageFile) {
                const imageFile = formData.imageFile;

                // Lire l'image pour vérifier ses dimensions
                const imageBitmap = await createImageBitmap(imageFile);
                if (imageBitmap.width !== 1920 || imageBitmap.height !== 1080) {
                    toast.error("L'image doit être en 1920x1080 pixels.");
                    return;
                }
                const imageData = new FormData();
                imageData.append('productName', formData.description);
                imageData.append('price', 0); // Valeur factice si inutilisée
                imageData.append('description', formData.description);
                imageData.append('picture', formData.imageFile);

                const uploadResponse = await axios.post(
                    'https://office.le-celadon.ma/uploadimagesgetUrl.php',
                    imageData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    }
                );

                if (!uploadResponse.data.success) {
                    alert('Erreur lors de l’upload de l’image : ' + uploadResponse.data.error);
                    return;
                }

                // Affecter l'URL reçue dans le champ `url`
                finalFormData.url = uploadResponse.data.filename;
            }

            // Envoyer les données finales
            if (currentSlideShow?._id) {
                const res = await axios.put(`${process.env.REACT_APP_PEGASUS_API_URL}/slide/${currentSlideShow._id}`, finalFormData, header());
                if (res.data.result) {
                    toast.success("Modification du Slide effectuéé avec succès");
                } else {
                    toast.error("Problème lors de la modification du slide");
                }
            } else {
                const res = await axios.post(`${process.env.REACT_APP_PEGASUS_API_URL}/slide`, finalFormData, header());
                if (res.data.result) {
                    toast.success("Ajout du Slide effectuéé avec succès");
                } else {
                    toast.error("Problème lors de l'ajout du slide");
                }
            }
            onSave();
            setFormData(defaultForm);


        } catch (error) {
            toast.error('Erreur lors de la sauvegarde du slideshow', error);
            alert("Une erreur est survenue. Merci de réessayer.");
        }
    };


    return (
        <>
            <Modal modalId="slideShowForm" title={currentSlideShow ? 'Modifier le Slide' : 'Ajouter un Slide'} modalType="modal-lg" submitLabel={currentSlideShow ? 'Modifier' : 'Ajouter '} onSubmit={handleSubmit}>
                <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                        <label>Description</label>
                        <input
                            type="text"
                            className="form-control"
                            name="description"
                            value={formData.description}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="mb-3">
                        <label>Image</label>
                        <input
                            type="file"
                            className="form-control"
                            accept="image/*"
                            onChange={(e) => {
                                const file = e.target.files[0];
                                if (file) {
                                    const preview = URL.createObjectURL(file);
                                    setFormData(prev => ({
                                        ...prev,
                                        imageFile: file,
                                        preview: preview,
                                    }));
                                }
                            }}
                        />
                    </div>

                    {(formData.preview || formData.url) && (
                        <div className="mb-3">
                            <label>Prévisualisation de l’image</label>
                            <div>
                                <img
                                    src={formData.preview || `${process.env.REACT_APP_DATA_PIC_PATH}/${formData.url}`}
                                    alt="Aperçu"
                                    style={{ maxWidth: '100%', maxHeight: 200, borderRadius: 8 }}
                                />
                            </div>
                        </div>
                    )}


                    <div className="mb-3">
                        <label>Magasins</label>
                        <Select
                            isMulti
                            options={storeOptions}
                            onChange={handleStoreChange}
                            value={storeOptions.filter(opt =>
                                formData.stores.map(s => s.storeid).includes(opt.value) // ✅ match on `value`
                            )}
                        />
                        {formData.stores.map((store, index) => {
                            const selectedOption = storeOptions.find(opt => opt.value === store.storeid);
                            return (
                                <div key={store.storeid} className="border rounded p-2 mb-2">
                                    <strong>{selectedOption?.label || 'Magasin sélectionné'}</strong>
                                    <div className="row mt-2">
                                        <div className="col-md-6">
                                            <label>Position</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={store.position}
                                                onChange={(e) => {
                                                    const updatedStores = [...formData.stores];
                                                    updatedStores[index].position = parseInt(e.target.value) || 0;
                                                    setFormData(prev => ({ ...prev, stores: updatedStores }));
                                                }}
                                            />
                                        </div>
                                        <div className="col-md-6 d-flex align-items-end">
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id={`activated-${store.storeid}`}
                                                    checked={store.activated}
                                                    onChange={(e) => {
                                                        const updatedStores = [...formData.stores];
                                                        updatedStores[index].activated = e.target.checked;
                                                        setFormData(prev => ({ ...prev, stores: updatedStores }));
                                                    }}
                                                />
                                                <label className="form-check-label" htmlFor={`activated-${store.storeid}`}>
                                                    Activé
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}

                    </div>

                </form>
            </Modal>
        </>
    );
}

export default SlidesShowForm;
